module.exports = __webpack_public_path__ + "img/feed_consumed.e5998919.png";